// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"86505437","140":"169d3751","325":"0f50d1e6","672":"37c1b2c7","773":"0821ff4b"}[chunkId] + ".js";
};